import React, { Component } from "react";
import { connect } from "react-redux";

import {
  setCurrentCategory,
  setCurrentPage,
  validateUser,
} from "../actions/siteActions";

class NavButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: { open: false },
    };
  }

  setCat = () => {
    const { site } = this.props;
    site.current &&
      site.current.category &&
      site.current.category.id !== this.props.attributes.id &&
      this.props.setCurrentCategory(this.props.attributes);
    //this.props.validateUser(this.props.site.user);

    this.props.setCurrentPage(0);
  };

  render() {
    return (
      <button
        className="navButton"
        onClick={() => this.setCat()}
        style={{ backgroundColor: this.props.attributes.acf.varvus }}
      >
        {this.props.attributes.name}
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {
  setCurrentCategory,
  setCurrentPage,
  validateUser,
})(NavButton);
